const AUTH_REDIRECT_STORAGE_KEY = 'pipp.auth.redirect_path';

const sanitizeRedirectPath = (path) => {
  if (!path || typeof path !== 'string') return null;
  if (!path.startsWith('/')) return null;
  return path;
};

export const rememberAuthRedirectPath = (path) => {
  const safePath = sanitizeRedirectPath(path);
  if (!safePath) return;
  try {
    window.localStorage.setItem(AUTH_REDIRECT_STORAGE_KEY, safePath);
  } catch (_error) {
    // Ignore storage failures.
  }
};

export const getRememberedAuthRedirectPath = () => {
  try {
    return sanitizeRedirectPath(window.localStorage.getItem(AUTH_REDIRECT_STORAGE_KEY));
  } catch (_error) {
    return null;
  }
};

export const clearRememberedAuthRedirectPath = () => {
  try {
    window.localStorage.removeItem(AUTH_REDIRECT_STORAGE_KEY);
  } catch (_error) {
    // Ignore storage failures.
  }
};
